'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _arrow = require('../../utils/arrow');

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ARROW_BASE = _constants2.default.ARROW_BASE,
    ARROW_HEIGHT = _constants2.default.ARROW_HEIGHT,
    BOTTOM_ROTATE = _constants2.default.BOTTOM_ROTATE,
    LEFT_ROTATE = _constants2.default.LEFT_ROTATE,
    RIGHT_ROTATE = _constants2.default.RIGHT_ROTATE,
    TOP_ROTATE = _constants2.default.TOP_ROTATE;


var modifierConfig = {
  bottom: function bottom(_ref) {
    var theme = _ref.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.chrome700) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('bottom', theme.colors.base.shadowLight) + ';\n    left: 0;\n    margin: auto;\n    right: 0;\n    top: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    transform: rotate(' + BOTTOM_ROTATE + 'deg) !important;\n  ';
  },

  left: function left(_ref2) {
    var theme = _ref2.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.chrome700) + ';\n    bottom: 0;\n    box-shadow: ' + (0, _arrow.setBoxShadow)('left', theme.colors.base.shadow) + ';\n    margin: auto;\n    right: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    top: 0;\n    transform: rotate(' + LEFT_ROTATE + 'deg) !important;\n  ';
  },

  right: function right(_ref3) {
    var theme = _ref3.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.chrome700) + ';\n    bottom: 0;\n    box-shadow: ' + (0, _arrow.setBoxShadow)('right', theme.colors.base.shadow) + ';\n    left: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    margin: auto;\n    top: 0;\n    transform: rotate(' + RIGHT_ROTATE + 'deg) !important;\n  ';
  },

  top: function top(_ref4) {
    var theme = _ref4.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.chrome700) + ';\n    bottom: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('top', theme.colors.base.shadow) + ';\n    left: 0;\n    margin: auto;\n    right: 0;\n    transform: rotate(' + TOP_ROTATE + 'deg) !important;\n  ';
  }
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome700: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired,
      shadowLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var styles = '\n  height: ' + (0, _decisivUiUtils.px2rem)(ARROW_BASE) + ';\n  position: absolute;\n  width: ' + (0, _decisivUiUtils.px2rem)(ARROW_BASE) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Tooltip__Arrow', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Tooltip/Arrow.js
// module id = 1696
// module chunks = 2